<template>
  <div class="page">
    <div v-for="(item, i) in data">
      <div class="margin-top" v-if="item.strong == true">
        <strong> {{ item.title }}</strong>
      </div>
      <div class="margin-top" v-else ><span v-html="item.title"></span></div>
    </div>
    <div class="right">北京云圈科技有限公司</div>
  </div>
</template>

<script>
export default {
  name: "privatepolicy",
  data() {
    return {
      data: [
        { title: "亲爱的用户，您好：" },
        {
          title:"教育圈是由北京云圈科技有限公司（下称云圈）基于教育信息资源开发的应用产品。云圈非常重视您的个人信息或个人数据信息。在您仔细阅读、了解并同意本政策之前，不要向云圈提交任何个人信息、数据等隐私信息（下称“信息”）。如果您是未成年人，应当与父母或监护人共同审阅本协议，以确保您及您的父母或监护人了解本协议。" 
        },
        {title:"请注意，本政策是云圈针对信息处理和保护的主要策略，但本政策可能无法解决您的信息处理和保护的所有问题，因此云圈会针对某些特定服务提供特定隐私政策作为本政策的补充，以便在基于特定目的处理和保护您的信息时通知客户，请您在使用云圈产品或服务时，注意其他形式的此类通知。"},
        { title: "一、个人信息定义及范围", strong: true },
        { title: "（一）个人信息：指以电子或者其他方式记录的能够单独或与其他信息结合，识别特定自然人身份或者反映特定自然人活动情况的信息。", },
        { title: "（二）个人敏感信息：包括身份证件号码、手机号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。"},
        { title: "（三）本隐私政策中涉及的个人信息及个人敏感信息主要包括："},
        { title: "1.基本信息：姓名、性别、个人电话号码;"},
        { title: "2.网络身份标识信息（系统账号（含第三方）、IP地址及与前述有关的密码）；"},
        { title: "3.联系人信息：通讯录；"},
        { title: "4.教育圈使用数据（浏览及点击记录、软件使用记录、通过麦克风输入的内容、通过相机拍摄的图片）；"},
        { title: "5.个人常用设备信息（含硬件型号、操作系统类型）；"},
        { title: "6.个人位置信息（定位信息）；"},
        { title: "7.获取应用列表进行消息推送及应用升级。"},
        { title: "二、云圈如何收集及使用您的信息",strong: true},
        { title: "1.个人注册信息",strong: true},
        { title: "当您注册云圈账号时，我们会根据您的选择收集您的<strong>手机号</strong>，以帮助完成账号相关权益的保存。您还可以根据自身需求上传头像、昵称等信息，进而完善产品体验。"},
        { title: "请您妥善保管您的账号、密码，如您将密码告知他人、与他人共享注册账户或其他个人保管不善事由导致的任何个人信息泄露、丢失、被盗用或被篡改等，云圈不对此承担责任。"},
        { title: "2.获取设备权限",strong: true},
        { title: "2.1网络权限",strong: true},
        { title: "我们需要在得到您的同意后，获取您的<strong>网络连接</strong>，主要用于内容的获取、视频的播放及消息的通知。"},
        { title: "2.2相机权限",strong: true},
        { title: "我们需要在得到您的同意后，连接您的<strong>相机功能</strong>，主要用于根据个人需要的图片上传及好友二维码的识别。"},
        { title: "2.3语音权限",strong: true},
        { title: "我们需要在得到您的同意后，打开您的<strong>麦克风</strong>，用于应用中的语音互动功能的使用。"},
        { title: "2.4位置权限",strong: true},
        { title: "我们需要在得到您的同意后，获取您的<strong>位置</strong>，用于提供基于位置的互动服务的使用。"},
        { title: "2.5通讯录权限：",strong: true},
        { title: "我们需要在得到您的同意后，获取您的<strong>通讯录信息</strong>，用于提供基于通讯录的好友查找。"},
        { title: "2.6通知权限：",strong: true},
        { title: "我们需要在得到您的同意后，为您推送<strong>通知消息</strong>，用于提供资讯信息更新及应用内互动的及时提醒。"},
        { title:"为确保应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力,将存在一定频率通过系统发送广播唤醒本应用自后启动或关联启动行为，是因实现功能及服务所必要的；当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有关联启动。"},
        { title:"3.收集设备信息",strong:true},
        {title:'云圈会收集某些信息进行统计与分析，这类信息包括您的<strong>设备名称、设备的粗略地理位置信息 (例如设备所在的网络位置编码)、运营商网络ID(PLMN)、应用使用情况、您访问互联网的IP地址、IP设备存储。</strong>云圈收集并处理这类信息的唯一目的是：用于改善我们的产品、分析我们的运营效率、统计市场占有率、改善网络和服务的安全性，以及启用您的保障服务。'},
        {title:'4.第三方SDK信息',strong:true},
        {title:'4.1阿里推送',strong:true},
        {title:'用于应用中最新资讯、聊天消息提醒、信息提醒等功能的使用。<a style="color:#1677ff;" href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.3a6830e5i97iLR" target="_blank">点击查看第三方隐私政策</a>'},
        {title:'4.2腾讯浏览器',},
        {title:'用于应用中相关H5页面浏览功能的使用。<a style="color:#1677ff;" href="https://www.tencent.com/zh-cn/privacy-policy.html" target="_blank">点击查看第三方隐私政策</a>'},
        {title:'4.3腾讯Bugly',strong:true},
        {title:'用于应用中技术问题的监控与防范。<a style="color:#1677ff;" href="https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf" target="_blank">点击查看第三方隐私政策</a>'},
        {title:'4.4友盟',strong:true},
        {title:'友盟会收集您的设备序列号、设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID/SN、SIM 卡 IMSI 信息)以及手机号码，用于用户及其浏览信息的分析，便于提供更佳的用户体验。<a style="color:#1677ff;" href="https://www.umeng.com/page/policy" target="_blank">点击查看第三方隐私政策</a>'},
        {title:'4.5高德',strong:true},
        {title:'用于应用中地图位置相关的功能使用。<a style="color:#1677ff;" href="https://cache.amap.com/h5/h5/publish/238/index.html" target="_blank">点击查看第三方隐私政策</a>'},
        {title:'5. 去标识化信息的收集及使用',strong:true},
        {title:'“去标识化信息”是指无法识别特定个人身份的信息，例如我们应用的启动次数、页面的点击次数。云圈会收集这类信息，以了解用户如何使用我们的应用、产品或服务，如此云圈才能进行改善，以满足客户的需求。云圈可以自行决定是否基于任何其他目的，收集、使用、移转或披露非个人信息。'},
        {title:'三、云圈如何披露您的信息',strong:true},
        {title:'只有符合下列情况时，云圈才会披露您的信息。在下列情形之外，云圈绝不会将您的信息披露给第三方。'},
        {title:"1.您已明确同意",strong:true},
        {title:"在得到您的批准后，云圈才会将您的信息透露给其他公司。"},
        {title:"2.将您的信息披露给云圈关联公司或授权合作的第三方",strong:true},
        {title:"云圈可能需要通过某些合作方为您提供某些服务，因此云圈需要将您的部分信息共享给合作方，以便丰富我们的服务以及满足您的需求。"},
        {title:"3.依法律要求，披露您的信息",strong:true},
        {title:"依法律、法院等司法机关命令或其他法律程序的规定，或相关政府机关的要求，云圈可能会提供您的信息。在云圈涉及重组、合并或清算的情况下，您的信息可能也会提供给交易方。"},

        {title:"四、云圈如何更新、变更或检查您的信息",strong:true},
        {title:"您应该对所提交的信息的准确性负责，云圈将尽到商业上合理的努力，确保您信息的准确性。"},

        {title:"五、云圈如何保护您的信息",strong:true},
        {title:"云圈采取合理的预防措施，包括但不限于物理上、技术及制度等方面，以保护您的信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失。例如，在技术方面，云圈使用防病毒软件、加密保护监控我们的系统，以及增强我们数据中心的攻击防护；物理方面，云圈设定门禁措施及访问控制，仅允许需要这类信息的业务人员浏览；在制度方面，则通过对云圈员工进行安全与隐私保护知识培训，确保员工了解保护数据的重要性。虽然我们采用合理的措施来保护您的个人数据，但没有任何安全措施能够百分之百完美或牢不可破。但由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而导致您的信息泄露、丢失、被盗用或被篡改的，云圈无需承担责任，但应采取补救措施，按照规定及时告知您并向有关主管部门报告。"},
        {title:"六、云圈如何处理未成年人的信息",strong:true},
        {title:"云圈鼓励父母或监护人指导未成年人使用云圈的产品或服务。如果法律有相关规定，云圈不会在未征得监护人同意的前提下收集未成年人的信息。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为保护未成年人而使用或披露有关未成年人的信息。「未成年人」的定义应考虑适用的法律，以及各国家和地区的文化惯例。"},
        {title:"若您是未成年人的监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用云圈的产品或服务。如果您对您所监护的未成年人的个人信息有疑问，请通过第10条中的联系方式与我们联系。"},
       
        {title:"七、第三方服务提供商",strong:true},
        {title:"为方便您的访问并丰富您的体验，可能会有非云圈的第三方提供内容或网络链接。您可以选择是否访问这类链接或内容，是否使用这类第三方的服务或产品，但云圈对于这些并没有控制权。云圈无法控制第三方的任何隐私权和数据保护措施，这类措施不受本政策管理，本政策也不适用于您自行选择提供给第三方的任何信息，请您在使用这类第三方的服务或产品时查看第三方的隐私保护政策。"},
        {title:"八、信息传输",strong:true},
        {title:"云圈产品与服务可能会由位于世界不同国家或地区的资源与服务器提供。因此，您的信息可能会跨国界而传输到您使用我们服务所在国家或地区之外的国家和地区，那些国家或地区可能没有对信息提供具体保护的法律，或是实行不同的数据保护法。在这类情况下，云圈将采取措施，确保有法律基础可进行这类传输，以及依适用法律，会对您信息提供适当的保护，例如，通过使用相关授权单位核准的标准合约（必要时），以及通过使用其他适当的技术与信息安全措施。"},
        {title:"九、您的权利",strong:true},
        {title:"按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利："},
        {title:"1.访问权"},
        {title:"您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：帐号信息——如果您希望访问或编辑您的帐号中的个人资料信息、更改您的密码或关闭您的帐号等，您可以通过访问“教育圈-我的”执行此类操作。"},
        {title:"2.更正权"},
        {title:"当您发现我们处理的关于您的个人信息有错误时，您可以通过登录“教育圈”个人中心帐号资料栏进行修改。"},
        {title:"3.删除权"},
        {title:"在以下情形中，您可以向我们提出删除个人信息的要求："},
        {title:"(1) 如果我们处理个人信息的行为违反法律法规；"},
        {title:"(2) 如果我们收集、使用您的个人信息，却未征得您的同意；"},
        {title:"(3) 如果我们处理个人信息的行为违反了与您的约定；"},
        {title:"(4) 如果您不再使用我们的产品或服务，或您注销了账号；"},
        {title:"(5) 如果我们不再为您提供产品或服务；"},
        {title:"(6) 若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。"},
        {title:"当您被从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。"},
        {title:"4.撤回同意权"},
        {title:"您可以电话联系客服向我们提出撤回收集、使用个人信息的同意授权。撤回同意后，我们后续不会再处理您的个人信息。同时，我们会保障您拒绝接收基于您个人信息推送的商业广告的权利。在我们对外共享、转让、公开披露您的个人信息时，我们会向您提供撤回同意的通知。撤回同意不影响撤回前基于同意的您的个人信息处理。"},
        {title:"5.注销权"},
        {title:"您可以电话联系客服(+86)13522706617（周一至周日8:00-21:00）说明注销需求，我们将安排专业人员响应注销需求。若您需要注销账号，在<strong>教育圈APP内访问“我的--设置--注销账号--完成账号注销”。</strong>关于您注销账户的方式以及您应满足的条件，请详见《账号注销须知》。您注销账号后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。"},
        {title:"6.查询权"},
        {title:"您可以通过登录“教育圈”我的-帐号资料栏进行查询。"},
        {title:"7.约束信息系统自动决策"},
        {title:"在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。"},
        {title:"8.响应您的上述请求"},
        {title:"为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。"},
        {title:"我们将在三十天内做出答复。"},
        {title:"对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。"},
        {title:"十、本隐私政策的更新",strong:true},
        {title:"云圈可能会不定期修订本《隐私政策》的条款，云圈将通过产品更新，告知您通知您，请您更新最新版本的云圈产品查询修订后的《隐私政策》。在该种情况下，若您继续使用云圈的产品或服务，即表示同意受修订后的《隐私政策》的约束。"},
        {title:"十一、其他",strong:true},
        {title:'本隐私政策是云圈统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于云圈用户。'},
        {title:"十二、与云圈联络",strong:true},
        { title: "如果您有任何问题、意见或建议，以及要求删除后台的用户数据，您可以发邮件到jinengma01@163.com与我们联络。",strong: false},
        { title: "云圈保留本政策条款之解释权。",strong: false},
           
      ]
      
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
.page {
  display: block;
  width: 6.9rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  /* padding-right: 0.3rem;
  padding-left: 0.3rem; */
}

div {
  color: #666;
  font-size: 0.34rem;
  text-align: left;
  width: 100%;
  line-height: 0.6rem;
  font-weight: normal;
  letter-spacing: 1px;
}

.margin-top {
  margin-top: 0.3rem;
}
a{
  color:#1677ff;
}

.center {
  font-size: 0.36rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  text-align: center;
  color: #000;
}

.right {
  font-size: 0.36rem;
  color: #666;
  width: 100%;
  margin-top: 0.6rem;
  float: right;
  text-align: right;
  margin-bottom: 0.6rem;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue